import React, { useRef, useState } from 'react';
import parse from "html-react-parser";
import { useNewHomeAPI } from '../../hooks/useAllCategoryData';
import ShimmerSingleBox from '../ShimmerSingleBox';

const videos = [
  { id:1, title:'The MANCHALI edit', text:'A collection of vibrant prints and refined silhouettes <br /> blended for effortlessly chic, everyday elegance.', src:'Manchali-Launch.mp4', thumbnail:'manchali-edit.jpg', videopop:'Take a sneak peek', url:'/category/indo-westerns?category_product=indo-westerns-the-manchali-edit&orderBy=default' },
  { id:2, title:'The RUHANI edit', text:'Our bouquet of classy and elegant co-ord sets, <br /> designed to blend sophistication with effortless style.', src:'Ruhani-Edit-Launch.mp4', thumbnail:'ruhani-edit.jpg', videopop:'Take a sneak peek', url:'/category/indo-westerns?category_product=indo-westerns-the-ruhani-edit&orderBy=default' },
  { id:3, title:'FESTIVE Collection', text:'Celebrate with our vibrant collection of ethnic shararas and straight fits, <br /> blending tradition with bold, bright colors.', src:'', thumbnail:'festive-collection.jpg', videopop:'', url:'/category/festive-flair?category_product=festive-flair&orderBy=default' },
  { id:4, title:'INDO WESTERNS', text:'An ensemble trendy Indo-Western dresses, fusing modern styles, <br /> vibrant colors, and effortless wearability for every occasion.', src:'', thumbnail:'indo-westerns.jpg', videopop:'', url:'/category/indo-westerns?category_product=indo-westerns_indo-westerns-the-ruhani-edit_indo-westerns-the-manchali-edit_indo-westerns-the-glam-edit&orderBy=default' }
];

const VideoGallery = () => {



    const [selectedVideo, setSelectedVideo] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const videoRef = useRef(null); // Reference to the video element
  
    const handleVideoSelect = (e) => {
      setSelectedVideo(e);
      setIsModalOpen(true);
    };
  
    const closeModal = () => {
      setIsModalOpen(false);
      if (videoRef.current) {
        videoRef.current.pause(); // Stop the video when modal closes
        videoRef.current.currentTime = 0; // Reset to the beginning
      }
    };
    const { isLoading, error, data } = useNewHomeAPI();
    if (error) return <div>{error.message}</div>;
  return (
    <>      
      <div className="category-full">
      <div className="container">
      {isLoading && ( <div className="products home-banner-shimmer">
          {Array.from({ length: 1 }, (_, index) => (
            <ShimmerSingleBox key={index} CustomStyle={{ height: "1510px" }} />
          ))}
        </div> )}
      {data?.videoGellery && (
        <ul>

{data.videoGellery.map((e,i) => (
<li key={i}>
  <div className="img-box"><a href={e.url}><img src={`${process.env.REACT_APP_IMAGE_URL}/home/category-img/${e.thumbnail}`} alt={e.title} /></a></div>
  <h2><a href={e.url} className="newfont-heading">{e.title}</a></h2>
  <p>{e?.text && parse(e.text)}</p>
  {e?.videopop &&(<div className="viewvideobtn"><span onClick={() => handleVideoSelect(e)}>{e.videopop}</span></div>)}
  <div className="viewmorebtn"><a href={e.url}>EXPLORE</a></div>
</li>
))}
</ul>)}</div>
      </div>
      {isModalOpen && (
        <div className="video-modal">
            <div className="video-overlay"><span className="close" onClick={closeModal}></span></div>
          <div className="video-modal-content">
            <span className="close mobile-video-close" onClick={closeModal}></span>
            {selectedVideo && (             
                <video ref={videoRef} width="528" height="937" controls autoPlay  playsInline webkitPlaysInline preload="auto">
                  <source src={`${process.env.REACT_APP_IMAGE_URL}/home/category-img/${selectedVideo.src}`} type="video/mp4" />
                </video>             
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default VideoGallery;